export { default as InsertChartIcon } from "@mui/icons-material/InsertChart";
